/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { fetchBooks } from '../actions';
import SearchBar from './search-bar';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display_mission: false,
    };
  }

  componentDidMount() {
    this.props.fetchBooks();
  }

  renderCTA = () => {
    return (
      <div className="CTA">
        <h1>Discover the stories left out
          of mainstream education.
        </h1>
        <div className="join-us">
          <p>Like what you find?</p>
          <p><NavLink id="join-button" to="/signup">Join</NavLink> our <span id="mission-button" onClick={this.handleMissionClick}>mission</span></p>
        </div>
      </div>
    );
  }

  renderMissionStatement = () => {
    return (
      <div className="mission-statement">
        <p>In education, only the majority gets to write their perspective on the events of history
          This tends to leave out the voices of BIPOC and LGBTQIA+ individuals.
        </p>
        <p>
          OurStories is a community education platform that makes it easier for people to share and learn about perspectives on history and society that are
          often left out of mainstream educational curricula and media. Our mission is to create an environment of knowledge-sharing that encourages
          critical thought about these perspectives and to stand in the shoes of people different from ourselves.
        </p>
        <i onClick={this.handleMissionBackClick} className="fas fa-long-arrow-alt-left" />
      </div>
    );
  }

  renderHomeText = () => {
    return (this.state.display_mission
      ? (
        <div className="homeText">
          {this.renderMissionStatement()}
        </div>
      ) : (
        <div className="homeText">
          {this.renderCTA()}
        </div>
      ));
  }

  handleMissionClick = () => {
    this.setState({ display_mission: true });
  }

  handleMissionBackClick = () => {
    this.setState({ display_mission: false });
  }

  renderBookA = (book) => {
    // reference: https://css-tricks.com/snippets/javascript/strip-whitespace-from-string/
    const bookName = (book.title).toLowerCase().replace(/\s+/g, '').replace(/\+/g, '');
    if (bookName === 'blackhistory' || bookName === 'aapihistory' || bookName === 'indigenoushistory' || bookName === 'latinxhistory') {
      return (
        <NavLink className="home-book-link" key={book.id} to={`/books/${book.id}/chapters`}>
          <div className="book" id={bookName} key={book.id}>
            <h1>{book.title}</h1>
          </div>
        </NavLink>
      );
    } else {
      return <div key={book.id} />;
    }
  }

  renderBookB = (book) => {
    // reference: https://css-tricks.com/snippets/javascript/strip-whitespace-from-string/
    const bookName = (book.title).toLowerCase().replace(/\s+/g, '').replace(/\+/g, '');
    if (bookName === 'intersectionalfeminism' || bookName === 'lgbtqhistory' || bookName === 'personalnarratives') {
      return (
        <NavLink className="home-book-link" key={book.id} to={`/books/${book.id}/chapters`}>
          <div className="book" id={bookName} key={book.id}>
            <h1>{book.title}</h1>
          </div>
        </NavLink>
      );
    }
    if (bookName === 'contributors') {
      return (
        <NavLink className="home-book-link" key={book.id} to="/contributors">
          <div className="book" id={bookName} key={book.id}>
            <h1>{book.title}</h1>
          </div>
        </NavLink>
      );
    } else {
      return <div key={book.id} />;
    }
  }

  renderNotebook = () => {
    if (this.props.auth) {
      return (
        <NavLink className="home-book-link" to="/notebook">
          <div className="book" id="notebook">
            <h1>My Notebook</h1>
          </div>
        </NavLink>
      );
    } else {
      return <></>;
    }
  }

  render() {
    return (
      <div className="page-container">
        <SearchBar />
        <div className="bookshelf">
          <div className="bookGroup">
            {this.renderHomeText()}
            {this.props.books.map((book) => {
              return (
                this.renderBookA(book)
              );
            })}
          </div>
          <div id="shelfA" />
          <div className="bookGroup">
            {this.props.books.map((book) => {
              return (
                this.renderBookB(book)
              );
            })}
          </div>
          <div id="shelfB" />
          <div className="bookGroup">
            {this.renderNotebook()}
          </div>
          <div id="shelfC" />
          <div id="footer">
            <p className="hint">Hint: get started by opening a book.</p>
          </div>
        </div>
      </div>
    );
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state) => (
  {
    books: state.books.all,
    auth: state.auth.authenticated,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
export default withRouter(connect(mapStateToProps, { fetchBooks })(Home));

// // static for testing
// export default Home;
